function e(e,r){return r||(r=e.slice(0)),Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(r)}}))}export default e;
//# sourceMappingURL=taggedTemplateLiteral.js.map
